import React, {Fragment, useEffect, useState} from "react"
import {
    Button,
    CardTitle,
    Col,
    Form,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Progress,
    Row,
    Spinner,
    Table
} from "reactstrap"
import PropTypes from "prop-types"
import {ToastContainer, toast} from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {Slide} from "react-toastify"
import API from "../../api"
import Select from "react-select";
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import {Link} from "react-router-dom";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import FileDownload from "js-file-download"

const VerificationEtudiant = props => {
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false)
    const [id, setId] = useState("")
    // Data Table
    const [orders, setOrders] = useState([])
    const [delet, setDelet] = useState(0);
    const [cloture, setCloture] = useState(0);
    const [semestre, setSemestre] = useState([
        {value: 1, label: "Semestre 1"},
        {value: 2, label: "Semestre 2"},
        {value: 3, label: "Session Contôle semestre 1"},
        {value: 4, label: "Session Contôle semestre 2"},
    ])
    const [cycle, setCycle] = useState([
        {value: 1, label: "Licence"},
        {value: 2, label: "Mastère"}
    ])
    const [selectSemestre, setSelectSemestre] = useState("")
    const [niveau, setNiveau] = useState([])
    const [selectNiveau, setSelectNiveau] = useState("")
    const [specialite, setSpecialite] = useState([])
    const [selectSpecialite, setSelectSpecialite] = useState("")
    const [modalDeleteGroup, setModalDeleteGroup] = useState(false);
    const [excel, setExcel] = useState(0);
    const [annee, setAnnee] = useState("");
    const [selectCycle, setSelectCycle] = useState("");
    const [semestreId, setSemestreId] = useState("");
    const [capacite, setCapacite] = useState("");
    const [add, setAdd] = useState(0)
    const [modalAfficher, setModalAfficher] = useState(false)
    const pageOptions = {
        loading: true,
        hidePageListOnlyOnePage: true,
        totalSize: orders.length,
        page: 1,
        nextPageText: "Suivant",
        prePageText: "Précédent",
        alwaysShowAllBtns: true,
        sizePerPageList: [
            {
                text: "50",
                value: 50,
            },
            {
                text: "100",
                value: 10,
            },
            {
                text: "150",
                value: 150,
            },
            {
                text: "All",
                value: orders.length,
            },
        ],
    }
    var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
    var annee_id = userAuthScolarite.user.annee_id
    var user_id = userAuthScolarite.user.id

    const NoDataIndication = () => (
      <h6 style={{textAlign: "center"}}>No record to display</h6>
    )
    const Columns = () => [
        {
            dataField: "nom",
            text: "Nom du groupe",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "capacite",
            text: "Capacité",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "nombre_etudiants",
            text: "Nombre d'étudiant",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
    ]
    const {SearchBar} = Search
    useEffect(async () => {
        setSelectCycle("")
        setSelectNiveau("")
        setSelectSpecialite("")
        setOrders([])
        const fetchAnnee = async () => {
            const resD = await API.post("annee/get_by_id", {id: annee_id});
            setAnnee(resD.data.Annee.annee_scolaire);
        };
        await fetchAnnee()
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
          user.sous_menu.some(subMenu => subMenu.sous_menu === "Groupe d'examen")
        );
        setAdd(typeArticleSubMenu.sous_menu[0].add)
        setDelet(typeArticleSubMenu.sous_menu[0].delete)
        setExcel(typeArticleSubMenu.sous_menu[0].exel)

        const resNiveau = await API.get("niveau/select").then(resNiveau => {
            setNiveau(resNiveau.data.Niveau)
        })
        setLoading(true)
    }, [props.semestre])
    useEffect(() => {
        setModal(false)
    }, [orders])
    const getSpecialite = async event => {
        setSelectSpecialite("")
        setSelectNiveau(event)
        const res = await API.post("group/get_list_spec_by_cycle", {
            niveau_id: event.value,
            semestre_id: [props.semestre],
            cycle_id: selectCycle.value,annee_id
        }).then(res => {
            setSpecialite(res.data.Groups)
        })
    }
    const getList = async event => {
        setSelectSpecialite(event)
        const res = await API.post("groupe_examen/liste_etudiant_par_capacite", {
            specialite_id: event.value,
            niveau_id: selectNiveau.value,
            semestre_id: props.semestre.value,
            cycle_id: selectCycle.value,
            annee_id
        }).then(res => {
            setOrders(res.data.etudiants)
        })
    }
    const getCycle = async event => {
        setSelectCycle(event)
        setSelectSemestre("")
        setSelectNiveau("")
        setSelectSpecialite("")
    }
    const toggleDeleteGroup = id => {
        if (selectCycle === "" && selectNiveau === "" && selectSpecialite === "") {
            toast.error("⛔ Tous les champs sont obligatoire !", {
                containerId: "A",
            })
        } else {
            setModalDeleteGroup(!modalDeleteGroup)
            setId(id)
        }
    }
    const toggleDeleteGroupExamen = async () => {
        setModalDeleteGroup(false)
        const res = await API.post("groupe_examen/delete_group_examen", {
            specialite_id: selectSpecialite.value,
            niveau_id: selectNiveau.value,
            semestre_id: props.semestre.value,
            user_id,
            annee_id
        }).then(res => {
            if (res.data.errNum === 301 || res.data.errNum === "301") {
                toast.error("⛔ " + res.data.msg, {
                    containerId: "A",
                })
            } else {
                const resD =  API.post("groupe_examen/liste_etudiant_par_capacite", {
                    specialite_id: selectSpecialite.value,
                    niveau_id: selectNiveau.value,
                    semestre_id: props.semestre.value,
                    cycle_id: selectCycle.value,
                    annee_id
                }).then(res => {
                    setLoading(true)
                    setOrders(res.data.etudiants)
                })

            }

        })
    }
    return (
      <React.Fragment>
          <div>
              {loading ? (
                <Row>
                    <Col xs="12">
                        <ToolkitProvider
                          keyField="id"
                          data={orders}
                          columns={Columns()}
                          search
                          bootstrap4
                        >
                            {toolkitProps => (
                              <div style={{ marginTop: "15px" }}>
                                  <CardTitle style={{ color: "#556ee6" }} className="h4">
                                      Critéres de Recherche
                                  </CardTitle>
                                  <Form className="mt-4">
                                      <Row>
                                          <Col md={4}>
                                              <div className="mb-3">
                                                  <Label for="basicpill-firstname-input1">Cycle:</Label>
                                                  <Select
                                                    options={cycle}
                                                    isSearchable={true}
                                                    onChange={e => getCycle(e)}
                                                    value={selectCycle}
                                                  />
                                              </div>
                                          </Col>
                                          <Col lg="4">
                                              <div className="mb-3">
                                                  <Label for="basicpill-firstname-input1">Niveau</Label>
                                                  <Select
                                                    options={niveau}
                                                    isSearchable={true}
                                                    value={selectNiveau}
                                                    onChange={e => getSpecialite(e)}
                                                  />
                                              </div>
                                          </Col>
                                          <Col lg="4">
                                              <div className="mb-3">
                                                  <Label for="basicpill-firstname-input1">Spécialité</Label>
                                                  <Select
                                                    options={specialite}
                                                    value={selectSpecialite}
                                                    isSearchable={true}
                                                    onChange={e => getList(e)}
                                                  />
                                              </div>
                                          </Col>
                                      </Row>
                                  </Form>
                                  <div style={{ display: "flex", justifyContent: "center" }}>

                                      <Col lg="12">
                                          <div className="text-center mt-4">


                                              {cloture !== 1 ? (
                                                delet === 1 ? (
                                                  <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: "#761C19",
                                                        borderColor: "#761C19",
                                                    }}
                                                    className="btn btn-success mb-2 me-2"
                                                    onClick={toggleDeleteGroup}>
                                                      {"Supprimer les étudiants pour cette spécialité"}
                                                  </button>
                                                ) : null
                                              ) : null}



                                          </div>
                                      </Col>

                                  </div>
                                  <Col sm="4">
                                      <div className="search-box me-2 mb-2 d-inline-block">
                                          <div className="position-relative">
                                              <SearchBar {...toolkitProps.searchProps} />
                                              <i className="bx bx-search-alt search-icon" />
                                          </div>
                                      </div>
                                  </Col>
                                  <BootstrapTable
                                    wrapperClasses="table-responsive"
                                    noDataIndication={() => <NoDataIndication />}
                                    striped={false}
                                    bordered={false}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"table-light"}
                                    hover
                                    pagination={paginationFactory(pageOptions)}
                                    {...toolkitProps.baseProps}
                                  />
                              </div>
                            )}
                        </ToolkitProvider>
                    </Col>
                </Row>
              ) : (
                <div>
                    <div
                      style={{
                          display: "flex",
                          justifyContent: "center",
                      }}
                    >
                        {" "}
                        <Spinner type="grow" className="ms-6" color="primary" />
                    </div>
                    <h4
                      style={{ textAlign: "center", marginTop: "2%" }}
                      className="ms-6"
                    >
                        {" "}
                        En cours ...{" "}
                    </h4>
                </div>
              )}
          </div>
          <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
          />
          <Modal isOpen={modalDeleteGroup} toggle={toggleDeleteGroup} centered={true}>
              <ModalHeader
                style={{width: "100% !important", textAlign: "center !important"}}
                toggle={toggleDeleteGroup}
                tag="h4"
              >
                  {"Suppression des étudiants de cette spécialité"}
              </ModalHeader>
              <ModalBody>
                  <div
                    style={{
                        fontFamily: "Montserrat, sans-serif",
                        FontSize: "14px",
                        FontWeight: "700",
                        LineHeight: "18.375px",
                    }}
                  >
                      <div style={{display: "flex", justifyContent: "center"}}>
                          <p>{"Voulez-vous supprimer des étudiants de cette spécialite ?"}</p>
                      </div>
                      <div
                        className="hvr-push"
                        style={{
                            display: "flex",
                            justifyContent: "space-around",
                            marginBottom: "15px",
                        }}
                      >
                          <div>
                              <Button
                                color="info"
                                className="btn-rounded "
                                onClick={toggleDeleteGroupExamen}
                              >
                                  <i
                                    style={{color: "white"}}
                                    className="far fa-thumbs-up"
                                  ></i>
                                  Oui
                              </Button>
                          </div>
                          <div>
                              <Button
                                onClick={toggleDeleteGroup}
                                color="danger"
                                className="btn-rounded "
                              >
                                  <i
                                    style={{color: "white"}}
                                    className="far fa-thumbs-down"
                                  ></i>
                                  Non
                              </Button>
                          </div>
                      </div>
                  </div>
              </ModalBody>
          </Modal>
      </React.Fragment>
    )
}

export default VerificationEtudiant
VerificationEtudiant.propTypes = {
    history: PropTypes.object,
    back: PropTypes.object,
    setSection: PropTypes.object,
    semestre: PropTypes.object,
    t: PropTypes.any,
}
